import { render, staticRenderFns } from "./Rewards-claimed.vue?vue&type=template&id=65e4ed40&scoped=true"
import script from "./Rewards-claimed.vue?vue&type=script&lang=js"
export * from "./Rewards-claimed.vue?vue&type=script&lang=js"
import style0 from "./Rewards-claimed.vue?vue&type=style&index=0&id=65e4ed40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4ed40",
  null
  
)

export default component.exports